//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, { useContext, useReducer, useEffect, Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// custom pages
import Loader from 'components/Loader/CenteredLoader';
import { useTranslation } from 'react-i18next';
import indexRoutes from 'routes/index';
import Context from 'context/context';
import Reducer from 'reducer/reducer';
import auth from 'apis/auth/auth';
import authRoutes from 'routes/AuthRoutes/authRoutes';
import './assets/css/index.css';
import './i18n';

let history = createBrowserHistory();

// setting the routes
const Routing = indexRoutes.map((route, i) => {
  if (route.redirect) return <Redirect key={i} to={route.to} />;
  return (
    <Route
      key={i}
      path={route.path}
      component={() => <route.component key={`component${i}`} />}
    />
  );
});

function Index() {
  const globalState = useContext(Context);
  const [state, dispatch] = useReducer(Reducer, globalState);
  const { t, i18n } = useTranslation();

  const { isLoggedIn } = auth();

  let location = useLocation();
  const history = useHistory();

  // handling loggedin api
  useEffect(() => {
    const param = new URLSearchParams(location.search);
    const token = param.get('token');
    if (token) {
      handleIsAuthorized();
    } else {
      handleIsLoggedIn();
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname == '/') {
      history.push('/login');
    }
  }, []);

  // loggedin api func --> whenever refresh app this willbe called
  const handleIsLoggedIn = async () => {
    try {
      let res = await isLoggedIn();
      if (res && Object.keys(res).length > 0 && res?.user) {
        // dispatch({ type: "SET_LOADING", payload: true })
        i18n.changeLanguage(res?.user?.language_code);
        dispatch({ type: "SET_ALA", payload: res?.loyaltyAccount });
        dispatch({ type: "SET_ACA", payload: res?.customerAccount });
        dispatch({
          type: 'SET_LANGUAGE',
          payload: res.language,
        });
        dispatch({ type: 'SET_USERINFO', payload: res.user });
        dispatch({ type: 'SET_ISLOGGEDIN', payload: true });
        dispatch({ type: 'SET_REDIRECTION_LINKS', payload: res.linksObj });
        // dispatch({ type: "SET_LOADING", payload: false })
        return;
      }
      let routes = authRoutes.map((a) => a.path);
      let currentPath = location.pathname;
      let isAuthRoute = routes.includes(currentPath);
      if (!isAuthRoute) {
        history.push('/login');
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // authorized routes func --> users comes from oneweb initially this will be called
  const handleIsAuthorized = async () => {
    let routes = authRoutes.map((a) => a.path);
    let currentPath = location.pathname;
    let isAuthRoute = routes.includes(currentPath);
    if (!isAuthRoute) {
      const param = new URLSearchParams(location.search);
      const token = param.get('token');
      if (token) {
        history.replace({ search: '' });
        let res = await isLoggedIn(token);
        if (res && res.user) {
          i18n.changeLanguage(res?.user?.language_code);
          dispatch({ type: 'SET_USERINFO', payload: res.user });
          dispatch({ type: 'SET_ISLOGGEDIN', payload: true });
          dispatch({ type: 'SET_ALA', payload: res?.loyaltyAccount });
          dispatch({ type: "SET_ACA", payload: res?.customerAccount });
          dispatch({
            type: 'SET_LANGUAGE',
            payload: res.language,
          });
          if(res?.loyaltyAccount?.['Loyalty_Account.tier'].toLowerCase() == 'bronze' && res.user?.role_id == null && !res.customerAccount?.signature_flag && !res.customerAccount?.startup_flag) {          
            sessionStorage.setItem('redeemBtnDisabled', true);
          }
          dispatch({ type: 'SET_REDIRECTION_LINKS', payload: res.linksObj });
          return;
        }
      } else {
        history.push('/login');
      }
      return;
    }
  };

  return (
    <Context.Provider value={{ state, dispatch }}>
      <ToastContainer />
      <Switch>{Routing}</Switch>
    </Context.Provider>
  );
}

ReactDOM.render(
  <Router history={history}>
    <Suspense fallback={<Loader Loading={true} />}>
      <Index />
    </Suspense>
  </Router>,
  document.getElementById('root')
);
